export function sportSortFunc(a, b) {
    var compare = a.get('priority') - b.get('priority');
    if (compare === 0) {
        compare = a.get('name').localeCompare(b.get('name'));
    }
    return compare;
}
export function leagueSortFunc(a, b) {
    var compare = a.get('priority') - b.get('priority');
    if (compare === 0) {
        compare = a.get('name').localeCompare(b.get('name'));
    }
    return compare;
}
export function matchSortFunc(a, b) {
    if (a.get('name') !== undefined && b.get('name') !== undefined) {
        return a.get('name').localeCompare(b.get('name'));
    }
}
export function matchStartDateSortFunc(a, b) {
    var compare = a.get('type') - b.get('type');
    if (compare === 0) {
        var aDate = a.get('startDate');
        var bDate = b.get('startDate');
        if (aDate > bDate) {
            return 1;
        }
        else if (aDate < bDate) {
            return -1;
        }
        return 0;
    }
    return compare;
}
export function outcomeSortFunc(a, b) {
    if (a.get('condition') !== undefined && b.get('condition') !== undefined) {
        return a.get('condition') - b.get('condition');
    }
}



// WEBPACK FOOTER //
// ./src/rendering-commons/Sorting.js